function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M64 64v320l88 58.4v-320zm104 59v320l80-53.2v-320zm280-59l-88 58.9v320l88-58.9zm-184 4.8v320l80 53.6v-320z"
});

const SvgComponent = props => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _ref);

export default __webpack_public_path__ + "static/media/ios-map.adc55d5c.svg";
export { SvgComponent as ReactComponent };